import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useMarketplaceCampaignsFilter } from './hooks';

export const MarketplaceCampaignsFilter = () => {
  const { filter, setFilterForm } = useMarketplaceCampaignsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export { useMarketplaceCampaignsFilter };
export * from './schemaTypes';
